<template>
  <div class="panel panel-board">
    <div class="panel-heading" :class="{'cursor': this.supportShrink}" v-if="data.title" @click="handleClickHeader">
      <slot name="header">
        <h3 class="panel-title">{{data.title}}</h3>
      </slot>
    </div>
    <div class="panel-body" v-show="show">
      <div :class="directionClass">
        <div v-for="(item, index) in items" :key="index" :class="['item', `item-${size}`, verticalColumn]">
          <div class="title" v-if="typeof(item.title) === 'string'">{{item.title}}</div>
          <div class="title" v-else-if="typeof(item.title) === 'object'">
              <component :is="item.title.is" v-bind="item.title.props" v-on="item.title.on || {}"></component>
          </div>
          <div :class="['content', `${item.modifier ? `--${item.modifier}` : ''}`]" v-if="item.type === 'images'">
            <a :href="img.image || img" target="_blank" v-for="(img, index) in item.content" :key="index">
              <img :src="img.icon || img">
            </a>
          </div>
          <div :class="['content', `${item.modifier ? `--${item.modifier}` : ''}`]" v-else-if="item.type === 'download'">
            <a :href="src"  v-for="(src, index) in item.content" :key="index" :download="getDownloadFileName(src)">{{item.text || `file${index+1}`}}</a>
          </div>

          <div :class="['content', `${item.modifier ? `--${item.modifier}` : ''}`]" v-else-if="item.type === 'cmp'">
            <component :is="item.is" v-bind="item.props" v-on="item.on || {}"></component>
          </div>

          <div
            v-else
            :class="['content', `${item.modifier ? `--${item.modifier}` : ''}`]"
            v-html="item.content"
            @click="handleClickContent(item)"
          ></div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>


export default {
  name: 'YamInfoPanel',
  props: {
    data: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    columnNO: {
      type: Number,
      default: 1
    },
    supportShrink: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },
    defaultShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: this.defaultShow
    }
  },

  computed: {
    items() {
      if (this.data.items && this.data.items.length) {
        return this.data.items.filter(item => !item.hide)
      }
      return []
    },
    directionClass() {
      if (this.direction === 'horizontal') {
        return 'horizontal-info'
      } else {
        return 'vertical-info'
      }
    },
    verticalColumn() {
      return this.columnNO === 1 ? '' : `vertical-column${this.columnNO}`
    }
  },

  methods: {
    handleClickHeader() {
      if (this.supportShrink) {
        this.show = !this.show
      }
    },
    handleClickContent(item) {
      if (typeof item.handleClick === 'function') {
        item.handleClick(item)
      }
    },

    getDownloadFileName(src) {
      return src && src.split('?')[0].split('/').pop() || ''
    }
  }
}
</script>

<style lang="stylus" scoped>
  .panel-board
    border-color #E7ECF1
    .panel-heading
      position relative
      border-color #E7ECF1
      background-color #fff
      padding 12px 30px
      .panel-title
        font-size 16px
        line-height 20px
    .panel-body
      padding 20px 30px

  .horizontal-info
    .item
      display flex
      min-height 20px
      line-height 20px
    .item-normal
      font-size 14px
    .item-small
      font-size 12px
    .item-normal+.item-normal
      margin-top 20px
    .item-small+.item-small
      margin-top 10px
    .item+.form-item
      margin-top 15px
    .form-item
      min-height 20px
      font-size 14px
      line-height 20px
    .form-item + .form-item
      margin-top 0
    .title
      flex 1
      color #666
    .content
      flex 2
      padding 0
      img
        max-width 220px
        display inline-block
        margin-right 10px
        margin-bottom 10px
      a
        margin-right 10px
        color $PRIMARY-BASE

  .vertical-info
    display flex
    flex-wrap wrap
    .item
      flex 1 1 0%
      display flex
      min-height 20px
      font-size 14px
      line-height 20px
    .form-item
      min-height 20px
      font-size 14px
      line-height 20px
    .form-item + .form-item
      margin-top 0
    .title
      flex 1
      color #666
    .content
      flex 2
      padding 0
      img
        max-width 220px
        display inline-block
        margin-right 10px
        margin-bottom 10px
      a
        margin-right 10px
        color $PRIMARY-BASE

    .vertical-column2
      flex 1 1 50%
      &:nth-child(n+3)
        margin-top 20px

    .vertical-column3
      flex 1 1 33.33%
      &:nth-child(n+4)
        margin-top 20px

    .vertical-column4
      flex 1 1 25%
      &:nth-child(n+5)
        margin-top 20px

  .--primary
    color $PRIMARY-BASE
  .--success
    color $SUCCESS-BASE
  .--danger
    color $DANGER-BASE

  .cursor
    cursor pointer
@media screen and (max-width $SCREEN-SM-MAX)
  .panel-board
    .panel-heading
      .panel-title
        font-size $MOBILE-FONT-SIZE-TITLE
  .horizontal-info
    .item
      font-size $MOBILE-FONT-SIZE-CONTENT
    .form-item
      font-size $MOBILE-FONT-SIZE-CONTENT
    .vertical-info
      .item
        font-size $MOBILE-FONT-SIZE-CONTENT
      .form-item
        font-size $MOBILE-FONT-SIZE-CONTENT
</style>
